import { CreateButton, List } from "@refinedev/antd";

import { AwardTypesList } from "./Award-Types-List";

export const AwardTypesPage = () => {
  return (
    <List
      title="Типы наград"
      resource={"award-types"}
      breadcrumb={false}
      canCreate={false}
      wrapperProps={{ style: { position: "sticky", top: 24 } }}
      headerButtons={
        <CreateButton resource={"award-types"}>
          Добавить тип награды
        </CreateButton>
      }
    >
      <AwardTypesList />
    </List>
  );
};
